import { groq } from 'next-sanity'
import cmsSettings from '../cmsSettings'
import { getRichTextFields } from '@/data/sanity/utils'
import imageAsset from '../imageAsset'
import button from '../button'

export const fields = groq`
  _type,
  _id,
  ${cmsSettings()},
  title,
  subtitle,
  description[] {${getRichTextFields({})}},
  ${imageAsset.fragment('image')},
  ${button.fragment('cta')},
`

export const fragment = (name = 'pagePromo') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
